import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, MenuItem, Divider, Typography } from '@mui/material';
import Markdown from '../../../reusable-components/markdown';
import { highlightText } from '../../../reusable-components/highlight-element/highlight-element';
import { fMonthDayYearShort } from '../../../utils/formatTime';
import QuickSearchDropdown from './QuickSearchDropdown';
import { invoicesAdvancedOrderSearch } from '../../../api/invoicing';
import { fToCurrency } from '../../../utils/formatText';

InvoiceSearchQuickDropdown.propTypes = {
  searchValue: PropTypes.string, 
  quickAdvancedFilter: PropTypes.bool,
  setQuickAdvancedFilter: PropTypes.func,
  advancedSearchBase: PropTypes.string,
  searchInputRef: PropTypes.object
}

export default function InvoiceSearchQuickDropdown({ searchValue, quickAdvancedFilter, setQuickAdvancedFilter, advancedSearchBase, searchInputRef }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState(null);

  const handleSearchCall = async () => {
    setLoading(true);
    const response = await invoicesAdvancedOrderSearch({
      searchValue,
      orderNumber: true,
      vendor: true,
      gls: true,
      facility: true,
      invoiceId: true,
      total: true,
      startDate: (() => { const d = new Date(); d.setMonth(d.getMonth() - 1); return d; })(),
      endDate: new Date(),
      pageNumber: 1,
      pageSize: 5
    }); 
    setSearchResults(response.data);
    setLoading(false);
  };

  const goToAdvancedSearch = () => navigate(`/dashboard/advanced-search?gls=true&facility=true&vendorInvoiceId=true&category=true&invoiceId=true&vendor=true&total=true&searchValue=${searchValue}&base=${advancedSearchBase}&page=1`);;
  const goToInvoice = (id) => {
    const route = `/dashboard/invoicing/${advancedSearchBase.slice(0, advancedSearchBase.indexOf('Invoicing'))}/${id}`;
    navigate(route)
  };

  const SearchResultItems = searchResults?.searchResults?.map(
    (res) => 
    <MenuItem key={res.id} onClick={() => goToInvoice(res.id)} sx={{ whiteSpace: 'break-spaces' }}>
      <Box sx={{ width: 575 }}>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Markdown
              sx={{ "& .MuiTypography-root": { fontWeight: "700" } }}
              children={`Invoice #${highlightText(res.invoiceId, searchValue)}`}
            />
            <Markdown
              children={
                [res.orderNumber ? `Order #${res.orderNumber}` : null, res.facility, res.vendor, fToCurrency(res.total)]
                  .filter(Boolean)
                  .map(val => highlightText(val, searchValue))
                  .join(' | ')
              }
            />
          </Box>
          <Typography sx={{ ml: 1 }} variant="caption">{fMonthDayYearShort(res.date)}</Typography>
        </Box>
        {
          res.glItems?.length > 0 &&
          <Markdown
            children={`GLs: ${highlightText(res.glItems.map(item => `${item.glCode} ${item.glMemo}`).join(' | '), searchValue)}`}
          />
        }
        <Divider color="black" sx={{ mt: .5 }} />
      </Box>
    </MenuItem>
  );

  return <QuickSearchDropdown
    loading={loading}
    handleSearchCall={handleSearchCall}
    goToAdvancedSearch={goToAdvancedSearch}
    searchResultItems={SearchResultItems}
    quickAdvancedFilter={quickAdvancedFilter}
    setQuickAdvancedFilter={setQuickAdvancedFilter}
    searchValue={searchValue}
    setSearchResults={setSearchResults}
    searchResults={searchResults}
    searchInputRef={searchInputRef}
  />
}